import * as React from 'react';
import Map from '../Map';
import Viewer from '../components/Viewer';
import logoKo from './images/logo-en.png';
// import Header from './Header';
// import Icon from '../Icon';
import styles from './Main.module.scss';
// import { Layout, Menu, Breadcrumb, Icon } from 'antd';
import { Layout, Menu, Breadcrumb, Icon } from 'antd';
// import 'antd/dist/antd.css';
import meta from '../Map/map.json';

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

function Main(props: any) {
  return (
    <div className={styles.root}>
      <Viewer data={meta} />
    </div>
  );
}

export default Main;
